import React, { useMemo } from 'react';
import DropDown from '../dropdown';
import { DiscountTypes } from '../constants';
import { useTextResources } from '../../../language';

const DiscountTypesDropDown = ({ ...props }) => {
    const text = useTextResources();

    const data = useMemo(()=>Object.keys(DiscountTypes).map((key) => {
      return {
        text: text(DiscountTypes[key]),
        key: key,
      };
    }), [text]); 

    return <DropDown data={data} textField='text' valueField='key' {...props} />;
  };


export default DiscountTypesDropDown;
